import { render, staticRenderFns } from "./AddPackageToRelease.vue?vue&type=template&id=753d1158"
import script from "./AddPackageToRelease.vue?vue&type=script&lang=js"
export * from "./AddPackageToRelease.vue?vue&type=script&lang=js"
import style0 from "./AddPackageToRelease.vue?vue&type=style&index=0&id=753d1158&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports